import angular from 'angular';
import '../core.module';
import { homeState } from '../constants/menu.constant';

function registerPermissionGuard($transitions) {
  $transitions.onBefore({ to: 'app.**' }, (transition) => {
    const permission = transition.to().data && transition.to().data.permission;
    if (!permission) return undefined;
    const SessionService = transition.injector().get('SessionService');
    if (!SessionService.hasPermission(permission)) {
      const target = homeState(SessionService) || 'app.dashboard';
      return transition.router.stateService.target(
        target === transition.to().name ? 'auth.login' : target
      );
    }
    return undefined;
  });
}

registerPermissionGuard.$inject = ['$transitions'];

angular.module('app.core').run(registerPermissionGuard);

export default registerPermissionGuard;
